export default __webpack_public_path__ + "static/media/sp_trash.15d05045.svg";